import { useState } from "react";
import styles from "./DataList.module.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DataList = ({ options, ...props }) => {
    const [isListOpen, setIsListOpen] = useState(false);
    return (
        <div className={styles.wrapper} onFocus={() => setIsListOpen(true)} onBlur={() => setIsListOpen(false)}>
            <input className={styles.dataList} list="options" {...props} />
            <datalist id="options">
                {
                    options !== undefined && options.map((option, index) => {
                        return <option key={index} value={option} />;
                    })
                }
            </datalist>
            <span className={styles.arrow}>
                {
                    isListOpen ? <FontAwesomeIcon icon={['fal', 'chevron-up']} /> : <FontAwesomeIcon icon={['fal', 'chevron-down']} />
                }
            </span>
        </div>
    );
}

export default DataList;